// frontend/src/services/membershipService.js
import api from './api';

/**
 * Check user's membership status in a group
 */
export const checkMembership = async (groupId) => {
  try {
    console.log('🔍 [Frontend] Checking membership for group:', groupId);
    
    const response = await api.get(`/membership/check/${groupId}`);
    
    console.log('✅ [Frontend] Membership response:', response.data);
    
    return response.data.data;
  } catch (error) {
    console.error('❌ [Frontend] Error checking membership:', error);
    
    // Fallback to safe defaults
    return {
      isCreator: false,
      isMember: false,
      hasPendingRequest: false,
      userRole: null,
      error: error.response?.data?.message || 'Failed to check membership'
    };
  }
};

/**
 * Get group details with membership status
 */
export const getGroupWithMembership = async (groupId) => {
  try {
    console.log('📋 [Frontend] Getting group with membership:', groupId);
    
    const response = await api.get(`/membership/group/${groupId}/with-membership`);
    
    console.log('✅ [Frontend] Group with membership response:', response.data);
    
    return response.data.data;
  } catch (error) {
    console.error('❌ [Frontend] Error getting group with membership:', error);
    
    // Fallback to regular group fetch
    try {
      const groupResponse = await api.get(`/groups/${groupId}`);
      return {
        ...groupResponse.data.data,
        membership: {
          isCreator: false,
          isMember: false,
          hasPendingRequest: false,
          userRole: null
        }
      };
    } catch (fallbackError) {
      throw error; // Throw original error
    }
  }
};

/**
 * Alternative: Simple local check (if API fails)
 */
export const checkMembershipLocally = (groupData, currentUser) => {
  if (!groupData || !currentUser || !currentUser._id) {
    return {
      isCreator: false,
      isMember: false,
      hasPendingRequest: false,
      userRole: null
    };
  }

  const currentUserId = String(currentUser._id);
  
  // Helper to extract ID
  const extractId = (item) => {
    if (!item) return null;
    if (typeof item === 'string') return item;
    if (item._id) return String(item._id);
    if (item.id) return String(item.id);
    return null;
  };

  // Check creator
  const creatorId = extractId(groupData.createdBy);
  const isCreator = creatorId === currentUserId;

  // Check member
  let isMember = false;
  let userRole = null;
  
  if (groupData.currentMembers && Array.isArray(groupData.currentMembers)) {
    const member = groupData.currentMembers.find(m => {
      if (!m || m.status !== 'approved') return false;
      const memberUserId = extractId(m.user);
      return memberUserId === currentUserId;
    });
    
    if (member) {
      isMember = true;
      userRole = member.role || 'member';
    }
  }

  // Check pending request
  let hasPendingRequest = false;
  if (groupData.joinRequests && Array.isArray(groupData.joinRequests)) {
    hasPendingRequest = groupData.joinRequests.some(r => {
      if (!r || r.status !== 'pending') return false;
      const requestUserId = extractId(r.user);
      return requestUserId === currentUserId;
    });
  }

  return { isCreator, isMember, hasPendingRequest, userRole };
};